import { PayloadAction } from '@reduxjs/toolkit';
import { initialState } from '.';

export const reducers = {
  setMountingPart(state, action: PayloadAction<any>) {
    state.isLoading = true;
  },
  setMountingPartSuccess(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.data = action.payload;
    state.error = null;
  },
  setMountingPartFailure(state, action: PayloadAction<any>) {
    state.isLoading = false;
    state.data = initialState.data;
    state.error = action.payload;
  },
};
